import { ActivitySortingType } from './types';

export const ACTIVITIES_PER_PAGE = 30;
export const DEFAULT_ACTIVITY_SORTING_TYPE = ActivitySortingType.RecentActivity;
